import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

const messages = {
	en: {
		view: {
			home: {
				menu: {
					home: "Home",
					about: "About",
					services: "Services",
					shops: "Shops",
					contact: "Contact Us"
				},
				wellcome: "Wellcome to Ramnic"
			},

			auth: {
				wellcome: "Wellcome to Ramnic",
				wellcomeCaption:
					"Follow the steps below to enter the customer club",
				information: "Please complete your information",
				enterAuthcode: "Please enter Authentication code",
				next: "Next",
				prev: "Previous step",
				login: "Login",
				signup: "Sign up"
			},
			club: {
				transactionDetails: "Transaction Details",
				menus: {
					dashboard: "Dashboard",
					transactions: "Transactions",
					transactionSplits: "transaction Splits",
					splitAnalytics: "Splits",
					cards: "cards",
					editProfile: "Edit Profile",
					signout: "Sign Out"
				}
			}
		},
		param: {
			record: "Record",
			nationalCode: "National code",
			firstName: "First Name",
			lastName: "Last Name",
			mobile: "Mobile",
			persianBirthDate: "Birth Date",
			birthDay: "Birth Day",
			birthMonth: "Birth Month",
			birthYear: "Birth Year",
			cityId: "City",
			address: "Address",
			authCode: "Authentication code",
			password: "Password",
			repeatPassword: "Repeat Password",
			cardHolderCardNumber: "Card Number",
			cardNumber: "Card Number",
			clientTerminal: "Terminal",
			transactionValue: "Transaction Value",
			splitCount: "Split Count",
			transactionPersianDate: "Transaction Persian Date",
			transactionTime: "Transaction Time",
			shopName: "Shop Name",
			shopAddress: "Shop Address",
			customerCardTypeName: "Card Type",
			splitYear: "Year",
			splitMonth: "Month",
			splitMonthName: "Month",
			totalSplitValue: "Split Value",
			status: "paid Status",
			amountPaid: "Amount Paid",
			subscribeToNews: "subscribeToNews"
		},
		validation: {
			head: "Please correct the following error(s)",
			required: "{label} field is required",
			invalid: "Invalid {label} field",
			auth: "Invalid Authentication code",
			login: "Invalid entry values",
			repeatPassword: "Invalid Repeat Password",
			duplicateMobile: "Duplicate Mobile",
			duplicateNationalCode: "Duplicate National Code",
			nationalCodeNotFound: "NationalCode Not Found"
		},
		errors: {
			server: "server error",
			login: "login error"
		}
	},
	fa: {
		view: {
			home: {
				menu: {
					home: "صفحه اصلی",
					about: "درباره ما",
					services: "خدمات",
					shops: "فروشگاه ها",
					contact: "ارتباط با ما"
				},
				wellcome: "به رامنیک خوش آمدید"
			},

			auth: {
				wellcome: "به رامنیک خوش آمدید",
				wellcomeCaption:
					"جهت ورود به باشگاه مشتریان لطفا کد ملی خود را وارد نمایید",
				information: "جهت تکمیل پروفایل لطفا مشخصات خود را وارد نمایید",
				enterAuthcode:
					"کد اعتبارسنجی به شماره موبایل {mobile} ارسال شد، این کد فقط 5 دقیقه معتبر است.",
				next: "ادامه",
				prev: "مرحله قبل",
				login: "ورود",
				signup: "ثبت نام"
			},
			club: {
				transactionDetails: "جزئیات تراکنش",
				menus: {
					home: "بازگشت به نیکارت",
					dashboard: "داشبورد",
					transactions: "تراکنش های خرید",
					tickets: "تیکت ها",
					transactionsGroup: "تراکنش های خرید گروهی ",
					transactionSplits: "اقساط تراکنش",
					splitAnalytics: "تحلیل اقساط",
					resetPassword: "تغییر کلمه عبور",
					cards: "کارت های شما",
					requests: "درخواست ها",
					shop: "فروشگاه های شما",
					terminals: "دستگاه ها",
					marketPlace: "ورود به بازارگاه",
					signout: "خروج"
				}
			}
		},
		param: {
			record: "ردیف",
			nationalCode: "کد ملی",
			firstName: "نام",
			lastName: "نام خانوادگی",
			fullName: "نام و نام خانوادگی",
			mobile: "موبایل",
			persianBirthDate: "تاریخ تولد",
			birthDay: "روز تولد",
			birthMonth: "ماه تولد",
			birthYear: "سال تولد",
			cityId: "محل سکونت",
			address: "آدرس",
			authCode: "کد اعتبارسنجی",
			password: "کلمه عبور",
			repeatPassword: "تکرار کلمه عبور",
			terms: "قوانین و مقررات",
			cardHolderCardNumber: "شماره کارت",
			cardNumber: "شماره کارت",
			clientTerminal: "ترمینال",
			transactionId: "شناسه تراکنش",
			ramnicWagePercent: "کارمزد",
			transactionValue: "مبلغ",
			transactionYear: "سال",
			transactionMonth: "ماه",
			transactionYearMonth: "تاریخ",
			transactionsCount: "تعداد تراکنش",
			splitCount: "تعداد اقساط",
			transactionPersianDate: "تاریخ",
			transactionTime: "ساعت",
			shopName: "نام فروشگاه",
			shopAddress: "آدرس فروشگاه",
			customerCardTypeName: "نوع کارت",
			splitYear: "سال",
			splitMonth: "ماه",
			splitMonthName: "ماه",
			totalSplitValue: "مبلغ قسط",
			status: "وضعیت",
			orderNumber: "شماره مرحله",
			actionTakenName: "وضعیت",
			personnelFullName: "نام اقدام گر",
			personnelRolName: "سمت اقدام گر",
			requestId: "شماره درخواست",
			requestTypeName: "نام درخواست/اقدام",
			requestTypeStatus: "وضعیت درخواست",
			comment: "توضیحات",
			persianCreateDate: "تاریخ",
			createTime: "ساعت",
			amountPaid: "مبلغ پرداخت شده",
			actions: "عملیات",
			question: "متن سوال",
			personnelCode: "کد پرسنلی",
			organizationId: "سازمان",
			cvv2: "cvv2",
			exYear: "سال انقضا",
			exMonth: "ماه انقضا",
			subscribeToNews: "اشتراک در خبرنامه پیامکی",
			terminal: "شماره پذیرنده",
			splitYear: "سال قسط",
			splitMonth: "ماه قسط",
			splitYearMonth: "تاریخ قسط",
			paymentPersianDate: "تاریخ واریز",
			accountNumber: "شماره حساب",
			amountPaid: "مبلغ",

			table: {
				perPage: "تعداد در هر صفحه",
				fromDate: "ازتاریخ",
				toDate: "تا تاریخ"
			},

			product: {
				record: "ردیف",
				name: "نام محصول",
				productName: "نام محصول",
				imagePath: "تصویر",
				actions: "عملیات",
				productStatusName: "وضعیت",
				productCategoryName: "نام گروه محصول",
				wagePercent: "کارمزد ماهیانه نیکارت",
				price: "قیمت به ریال",
				description: "توضیحات محصول",
				image: "تصویر محصول",
				count: "موجودی"
			},

			cart: {
				fullName: "نام و نام خانوادگی",
				mobile: "موبایل",
				address: "آدرس کامل",
				splitCount: "تعداد اقساط",
				cashPrice: "مبلغ کارت بانکی",
				splitPrice: "مبلغ اقساطی",
				wagePrice: "مبلغ کارمزد",
				postalCode: "کد پستی"
			},

			ticket: {
				title: "عنوان",
				statusName: "وضعیت",
				ticketRequestTypeName: "موضوع",
				trackingCode: "کد رهگیری",
				ticketPriorityName: "اولویت",
				docsLength: "تعداد فایل",
				persianCreateDate: "تاریخ ارسال",
				createTime: "ساعت",
			}
		},
		validation: {
			head: "لطفا اشتباهات زیر را اصلاح نمایید",
			required: "فیلد {label} اجباری است",
			invalid: "فیلد {label} نامعتبر است",
			auth: "کد اعتبار سنجی صحیح نیست",
			login: "مشخصات ورود نامعتبر است",
			repeatPassword: "کلمه عبور و تکرار آن یکسان نیستند",
			duplicateMobile: "شماره موبایل وارد شده قبلا در سیستم ثبت شده است",
			duplicateNationalCode:
				"کد ملی وارد شده قبلا در سیستم ثبت نام شده است",
			duplicatePersonnelCode:
				"کد پرسنلی وارد شده قبلا در سیستم ثبت نام شده است",
			nationalCodeNotFound: "کد ملی وارد شده در سیستم یافت نشد",
			terms: "لطفا قوانین و مقررات را مطالعه و تیک پذیرفتن را بزنید.",
			password2: "حداقل طول {label} باید 8 کاراکتر باشد"
		},
		errors: {
			server: "خطا در برقراری ارتباط با سرور",
			login: "خطا در عملیات ورود به سیستم",
			payment: "خطا در عملیات پرداخت",
			noAccess: "عملیات ناموفق",
			tokenError: "کلید ارسالی نامعتبر است",
			shahkarError: "شماره موبایل و کد ملی باید متعلق به یک شخص باشد.",
			shahkarServerError: "خطا در سرویس شاهکار",
			personnelCode:
				"شناسه کاربری شما غیرفعال است، لطفا با پشتیبانی نیکارت تماس بگیرید."
		}
	}
};

const i18n = new VueI18n({
	locale: "fa", // set locale
	fallbackLocale: "fa", // set fallback locale
	messages // set locale messages
});

export default i18n;
